import DOMPurify from "dompurify";
import { marked, Renderer } from "marked";

marked.setOptions({ breaks: true, gfm: true });

const renderer = new Renderer();
const originalLink = renderer.link.bind(renderer);
renderer.link = (token) => {
  const html = originalLink(token);
  return html.replace(/^<a /, '<a target="_blank" rel="noopener noreferrer" ');
};
marked.use({ renderer });

export function renderMessageContent(raw: string): string {
  if (!raw) return "";
  const trimmed = raw.trim();

  if (trimmed.startsWith("{")) {
    try {
      const parsed = JSON.parse(raw);
      if (parsed?.content_html && typeof parsed.content_html === "string") {
        return DOMPurify.sanitize(parsed.content_html);
      }
    } catch {
      // não é JSON válido — cai pro caminho markdown
    }
  }

  try {
    const html = marked.parse(raw, { async: false }) as string;
    return DOMPurify.sanitize(html);
  } catch (err) {
    console.error("Falha ao renderizar markdown da mensagem:", err);
    return DOMPurify.sanitize(`<p>${raw}</p>`);
  }
}
